import React from 'react';
import { TableColumn } from '../common/Table';

interface ReviewPanelProps<T> {
  row: T;
  columns: TableColumn[];
}

// Admin-only decision context shown alongside a file preview in the FileViewer side panel,
// so staff can approve/give feedback without leaving the file to cross-reference the table row.
// Renders directly from the table's own `columns` array (columns marked `showInReview: true`) so
// there's a single source of truth for what a table shows - no separate field list to keep in sync.
function ReviewPanel<T>({ row, columns }: ReviewPanelProps<T>): React.ReactElement {
  const reviewColumns = columns.filter((col) => col.showInReview);

  return (
    <div className="flex flex-col gap-3">
      {reviewColumns.map((col) => (
        <div key={col.key}>
          <div className="text-xs font-medium uppercase tracking-wide text-gray-400">{col.label}</div>
          <div className="text-sm text-gray-700">
            {col.render
              ? col.render(row)
              : col.format
                ? col.format((row as any)[col.key], row)
                : (row as any)[col.key]}
          </div>
        </div>
      ))}
    </div>
  );
}

export default ReviewPanel;
